import React, { useState } from 'react';
import { useAIContext } from 'src/context/AIContextBackend';
import styled from 'styled-components';
import { isSource } from '@annote/types';
import { MenuContainer, MenuItem, MenuProps, MenuInput } from './MenuComponents';

const PromptMenuItem = styled(MenuItem)`
  background-color: inherit;
  &:hover {
    background-color: inherit;
  }
`;

const AIMenu: React.FC<MenuProps> = ({ note, closeMenu, triggerRef }) => {
  const [inputValue, setInputValue] = useState<string>('');
  const { submitMessage } = useAIContext();

  // [Alias prompt, full prompt]
  const examplePrompts = isSource(note)
    ? [
        // prompts for Sources
        ['Create notes from this', 'Create notes from this'],
        ['Summarize this', 'Summarize this'],
        ['Connect to related documents', 'Connect this to related documents'],
        // ['Suggest other content based on this', 'Suggest other content based on this'],
        ['Find similar documents', 'Find similar documents'],
        ["Explain like I'm 5", "Explain this like I'm 5"],
        // ['Get counter points', 'Get counter points'],
        // ['Fact check this', 'Fact check this'],
        // ['Suggest questions', 'Suggest questions from this'],
      ]
    : [
        // prompts for Takeaways
        ['Proofread this', 'Proofread this'],
        ['Fill this out', 'Fill this out'],
        ['Fact check this', 'Fact check this'], // TODO - we don't have a way quite yet?
        ['Bulletize this', 'Bulletize this'],
        ['Give a critical review', 'Give a critical review'],
        ['Find similar documents', 'Find similar documents'],
        // ['Connect to related documents', 'Connect this to related documents'],
        ['Break this into subnotes', 'Break this into subnotes'],
        // ['Find sources', 'Find sources for this'],
      ];

  const handleExamplePromptClick = (prompt: string): void => {
    // Format the prompt to include context about the specific note
    const contextualPrompt = `Regarding the note with id: ${note.id} and title: "${note.title}": ${prompt}`;
    submitMessage(contextualPrompt);
    if (closeMenu) closeMenu();
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setInputValue(event.target.value);
  };

  const handleInputSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    handleExamplePromptClick(inputValue);
  };

  return (
    <MenuContainer triggerRef={triggerRef!}>
      <PromptMenuItem>
        <form onSubmit={handleInputSubmit}>
          <MenuInput placeholder="Enter your own prompt" value={inputValue} onChange={handleInputChange} />
        </form>
      </PromptMenuItem>
      {examplePrompts.map(([alias, full]) => (
        <MenuItem key={alias} onClick={() => handleExamplePromptClick(full)}>
          {alias}
        </MenuItem>
      ))}
    </MenuContainer>
  );
};

export default AIMenu;
